export const PAYMENT_DETAILS_FETCH = 'PAYMENT_DETAILS_FETCH';
export const PAYMENT_DETAILS_FETCH_DONE = 'PAYMENT_DETAILS_FETCH_DONE';

export const UPDATE_PAYMENT_DETAILS = 'UPDATE_PAYMENT_DETAILS';
export const UPDATE_PAYMENT_DETAILS_DONE = 'UPDATE_PAYMENT_DETAILS_DONE';

export const CARD_REPLACE = 'CARD_REPLACE';
export const CARD_REPLACE_DONE = 'CARD_REPLACE_DONE';

export const RENEW_SUBSCRIPTION = 'RENEW_SUBSCRIPTION';
export const RENEW_SUBSCRIPTION_DONE = 'RENEW_SUBSCRIPTION_DONE';

export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';
export const CANCEL_SUBSCRIPTION_DONE = 'CANCEL_SUBSCRIPTION_DONE';



// WEBPACK FOOTER //
// ./app/constants/paymentDetailsTypes.js